import { find, isEmpty } from 'lodash';
import ApplicationController from './application_controller';

/* global $, Cifra, I18n, swal */
export default class extends ApplicationController {
  connect() {
    this.gestionModificacionTipoNota();
    this.gestionAsignaturas();
    this.gestionSelectorCurso();
  }

  // eslint-disable-next-line class-methods-use-this
  gestionModificacionTipoNota() {
    // En creación no hacemos nada
    if (this.isNuevoRegistro()) {
      return;
    }

    const conversionDefectoIdInicial = $('#conversion_defecto_id').val();

    $('#tipo_nota_defecto_id, #conversion_defecto_id').on('change', (e) => {
      // No sé por qué jquery.chained lanza un change al cargar. De esta forma evitamos
      // que se muestre el mensaje de confirmación al cargar la página
      if (e.currentTarget.id === 'conversion_defecto_id'
          && $('#conversion_defecto_id').val() === conversionDefectoIdInicial) {
        return;
      }

      swal({
        title: I18n.t('atencion'),
        text: I18n.t('actualizacion_tipos_nota_confirmacion'),
        type: 'warning',
        confirmButtonColor: Cifra.Conf.COLOR_CIFRA,
        confirmButtonText: I18n.t('si'),
        showCancelButton: true,
        cancelButtonText: I18n.t('no'),
        closeOnConfirm: true,
      }, (isConfirmed) => {
        $('#actualizar_tipos_notas').val(isConfirmed);
        $('#label-actualizar').toggle(isConfirmed);
      });
    });
  }

  gestionAsignaturas() {
    this.asignaturas = new Cifra.Collections.Asignaturas();
    this.asignaturas.on('reset', function resetAsignaturas() {
      const asignaturaId = $('#asignatura_id').val();
      if (asignaturaId) {
        // Quitamos la asignatura actual de la lista
        this.remove(parseInt(asignaturaId, 10));
      }
    });

    this.selectAsignaturas = new Cifra.Components.Select({
      el: '#asignatura_asignatura_id',
      collection: this.asignaturas,
      emptyLabel: 'Ninguna',
      // Para que en el conservatorio se vea de qué instrumento es
      labelField: 'nombre_curso_modalidad',
    });

    /* eslint-disable-next-line no-new */
    new Cifra.Components.Select({
      el: '#asignatura_sustituye_id',
      collection: this.asignaturas,
      emptyLabel: 'Ninguna',
      // Para que en el conservatorio se vea de qué instrumento es
      labelField: 'nombre_curso_modalidad',
    });

    this.selectModalidades = new Cifra.Components.Select({
      el: '#asignatura_modalidad_id',
      collection: new Cifra.Collections.Modalidades(),
      emptyLabel: 'Ninguna',
    });

    // También carga las mismas asignaturas para el combo de sustituye_id
    this.cargarAsignaturasPadre = (ensennanzaId, cursoId) => {
      this.asignaturas.fetch({
        data: {
          inferiores: true,
          ensennanza_id: ensennanzaId,
          curso_id: cursoId,
          modalidad_id: $('#asignatura_modalidad_id').val() || undefined,
        },
        reset: true,
      });
    };

    // Si es edición puede no estar el selector
    if (this.selectModalidades.$el.length) {
      // Cargamos las asignaturas al renderizar o cuando cambian el valor seleccionado
      this.selectModalidades.on('render change', () => {
        this.cargarAsignaturasPadre(
          this.selectModalidades.ensennanzaId,
          this.selectModalidades.cursoId,
        );
      });
    } else {
      this.cargarAsignaturasPadre(
        this.selectAsignaturas.$el.data('ensennanza-id'),
        this.selectAsignaturas.$el.data('curso-id'),
      );
    }
  }

  gestionSelectorCurso() {
    const selectorCursoEl = document.getElementById('selector-curso');
    // En creación no hacemos nada
    if (!selectorCursoEl) {
      const cursoId = $('#asignatura_curso_id').val();

      // Si es edición, cogemos el id del curso y cargamos las modalidades directamente
      this.selectModalidades.cursoId = cursoId;
      this.selectModalidades.collection.fetch({
        data: {
          curso_id: cursoId,
        },
      });
      return;
    }

    this.selectorCurso = this.getControllerAsync(
      selectorCursoEl,
      'selector-estructura',
    ).then((controller) => {
      this.selectorCurso = controller.component;
      this.selectorCurso.on('option:selected clear', (type, selectedId, path) => {
        // FIXME: Esto no está bien porque presupone que selectedid es un curso y puede no serlo
        this.selectModalidades.cursoId = selectedId;
        if (selectedId) {
          const ensennanza = find(path, {
            type: 'ensennanza',
          });
          if (ensennanza) {
            this.selectModalidades.collection.fetch({
              data: {
                ensennanza_id: ensennanza.id,
                curso_id: selectedId,
              },
            });
            // Forzamos la carga porque si fetch retorna un array vacío no se lanza el evento change
            this.cargarAsignaturasPadre(ensennanza.id, selectedId);
          }
        } else {
          this.selectModalidades.collection.reset();
        }
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  isNuevoRegistro() {
    // Comprobamos si estamos en un formulario de creación
    return isEmpty($('#asignatura_id').val());
  }

  disconnect() {
    // Cleanup automático de jQuery event listeners y Backbone collections
    if (this.asignaturas) {
      this.asignaturas.off();
    }
    if (this.selectModalidades) {
      this.selectModalidades.off();
    }
    $('#tipo_nota_defecto_id, #conversion_defecto_id').off('change');
  }
}
